import React from 'react';

export const PageNotFound = () => {
    return <div className="not-found">Page Not Found</div>;
};
